module.exports = __webpack_public_path__ + "img/rejected.9d01bceb.svg";